import { Box, Typography, useTheme } from "@mui/material";
import { type FC, useEffect, useRef } from "react";

const STICKY_LABEL_HANDOFF_OFFSET_PX = 40;

type Props = {
	title: string;
	setStickyTitle: React.Dispatch<React.SetStateAction<string>>;
	hideGroupedListLabel?: boolean;
};

export const GroupedListLabel: FC<Props> = ({
	title,
	setStickyTitle,
	hideGroupedListLabel,
}) => {
	const theme = useTheme();

	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleScroll = () => {
			if (ref.current) {
				const rect = ref.current.getBoundingClientRect();

				if (rect.top < STICKY_LABEL_HANDOFF_OFFSET_PX) {
					setStickyTitle(title);
				}
			}
		};

		window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [setStickyTitle, title]);

	return (
		<Box
			ref={ref}
			sx={{
				padding: "8px 16px",
				textAlign: "left",
				display: hideGroupedListLabel ? "none" : "block",
			}}
		>
			<Typography
				variant="deprecatedH3"
				color={theme.palette.deprecated.grey[700]}
			>
				{title}
			</Typography>
		</Box>
	);
};
